import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import loaders from './loaders'

loadFonts()

const app = createApp(App);

// app.component('globe-object', loaders.GlobeObject)
app.component('zoom-buttons', loaders.ZoomButtons)
app.component('risk-key', loaders.RiskKey)
app.component('globe-foot-bar', loaders.GlobeFootBar)
app.component('download-pdf-button', loaders.DownloadPdfButton)

//Information Components
app.component('more-info-holder', loaders.MoreInfoHolder)
app.component('information-select-menu', loaders.InformationSelectMenu)
app.component('country-name-bar', loaders.CountryNameBar)
app.component('information-select-footer', loaders.InformationSelectFooter)

//Risk Components
app.component('risk-information', loaders.RiskInformation)

// ESG
app.component('esg-view', loaders.ESGView)

// Key Figures Components
app.component('key-figures', loaders.KeyFigures)



//Search
app.component('search-button', loaders.SearchButton)
app.component('search-widget', loaders.SearchWidget)

// Movement Focus
app.component('movement-focus-button', loaders.MovementFocusButton)
app.component('movement-focus', loaders.MovementFocus)
app.component('explore-button', loaders.ExploreButton)
app.component('movement-widget', loaders.MovementWidget)

// Industry Performance
app.component('industry-performance', loaders.IndustryPerformance)
app.component('industry-performance-scores', loaders.IndustryPerformanceScores)
app.component('compare-countries-button', loaders.CompareCountriesButton)
app.component('country-picker', loaders.CountryPicker)

app
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
